
jQuery(document).ready(function($) {

    $("body").on('click', '[data-toggle-pill]', function() {
        
        $(".sc-pill").removeClass('active');
        $(this).addClass('active');

        const pill_container_id = $(this).data("toggle-pill");

        $("[data-pill-content]").hide();
        $(`[data-pill-content=${pill_container_id}]`).show();
    });
})